
<template>

  <div class="atividades-sinistros ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <!-- -->
              <b-col cols="4">
                <label for="select-empresa-cor">Empresa</label> 
                <multiselect  id="selecao-empresa-cor-ind"  v-model="empresaf" 
                  :options="empresasf" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"                              
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="nomeempresarial" track-by="nomeempresarial" name="nomeempresarial"
              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="4">
                <label for="select-filial_cor">Filial</label> 
                
                <multiselect id="selecao-filial-coe-ind"  v-model="valor_filial"
                  :options="filiaisf" 
                  :multiple="true"                           
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>


              

              <b-col cols="2">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="2">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final" @input="loadKpiDia(),loadKpiPrograma(),loadKpiFuncao(),loadKpiFuncionario(),loadKpiFilial(),loadKpiQtd()" placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker> 

                </div>                     
              </b-col>

              
              <!-- 
              <b-col cols="1">
                <br>                 
                <b-button  variant="success" class="mr-2 mt-2" block @click="loadKpiDia(), loadKpiFuncao(),loadKpiQtd(),loadKpiFuncionario(),loadKpiPrograma(), loadKpiFilial()">
                   carregar
                </b-button>                      
              </b-col>
              -->

          </b-row>
    </b-form>   



          <!--  <b-card-group class="ml-3 mt-3 mb-3" deck>    -->
        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE DE ACESSO NO PERÍODO"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    

                      {{ kpiqtds.length  }}

                      
                  
                  </h2>
                </b-card-text>
              </b-card>   


        </b-card-group> 

    
    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>      
      <div >
        
        <!-- diário  -->
        <b-row>
  

          <b-col cols="12" class="mt-4" id="grafdia">            
            <apexcharts             
            ref="chartdia"
            height="400" 
            :options="graficoDia" 
            :series="seriesdia"
            >
            </apexcharts>
          </b-col>


        </b-row>

        

        <!-- acumulado  -->
        <b-row>
          
          <!-- acumulado  PROGRAMA
           -->
          <b-col cols="3">
            <apexcharts
            ref="chartprograma" 
            height="400" 
            :options="graficoPrograma" 
            :series="seriesprograma"
            ></apexcharts>
          </b-col>

          <!-- acumulado  função -->
          <b-col cols="3">
            <apexcharts 
            ref="chartfuncao"
            height="400" :options="graficoFuncao" 
            :series="seriesfuncao"></apexcharts>
          </b-col>

   


          <!-- acumulado  carro -->
          <b-col cols="3">
            <apexcharts 
            ref="chartfuncionario"
            height="400" :options="graficoFuncionario" 
            :series="seriesfuncionario"></apexcharts>
          </b-col>

                    <!-- acumulado  FILIAL -->
          <b-col cols="3">
            <apexcharts 
              ref="chart"
              height="400" 
              :options="graficoPizzaFilial"   
              :series ="graficoPizzaFilial.series"     
              
            >
            </apexcharts> 
            
                       
          </b-col>

        </b-row>

      </div>      
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
    


  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
import { onBeforeUpdate } from 'vue'


export default {  
  name: 'SolicitacaoPainel',

  components: {
    apexcharts: VueApexCharts,
    Multiselect
  },
    computed : { ... mapState (['user'],),

    } ,

    data: function() {    

        return {

  /* diario */
  graficoDia: {
    chart: {
              id: 'bar-dia',
              type: 'area',
              height: 350,                          
              foreColor:"black",
              toolbar: {
                show: false                
              },
              
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    }, 

   dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 
    
    
    title: {
      text: 'Acessos diários',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    },
    
  },



  
/* PROGRAMA    */
  graficoPrograma: {
    chart: {
              id: 'bar-programa',
              type: 'bar',
              height: 350,            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    }, 
    
        dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

    title: {
      text: 'PROGRAMA',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },


  
/* Função    */
  graficoFuncao: {
    chart: {
              id: 'bar-programa',
              type: 'bar',
              height: 350,            
              foreColor:"black",
              toolbar: {
                show: false
              },
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    xaxis: {  
            categories:[], 
              tickPlacement: 'of'            
    },
    
        dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

    title: {
      text: 'TOP 20 FUNÇÃO',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

  


  /* funcionario */
  graficoFuncionario: {
    chart: {
              id: 'bar-departamento',
              type: 'bar',
              height: 350, 
              foreColor:"black",
              toolbar: {
                show: false
              },
              
    },
    plotOptions: {
      bar: {        
        horizontal: true,
       // isFunnel: true,        
      }
    },
    xaxis: {  
      labels: {      
        maxWidth: 400,  // Define uma largura máxima para os rótulos        
      },    

      categories:[], 
      tickPlacement: 'of'            
    },    

    dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 
    title: {
      text: 'TOP 20 FUNCIONÁRIO(S)',
      align: 'center',
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize:  '22px',
        fontWeight:  'bold',
        color:  '#263238'
      },
    }
  },

    /* filial */  
  graficoPizzaFilial: {
          chart: {
            id: 'pizza-filial',             
            type: 'pie', 
            height: 350,                                      
            foreColor:"black",                         
                          //fontFamily: 'Arial, sans-serif', // Defina a fonte desejada
              fontSize: '122px', // Tamanho da fonte      
          },
          labels: [],
          legend: {
            show: true,             
            position: 'bottom',
          },
              dataLabels: {
          style: {
            fontSize: '18px', // Defina o tamanho da fonte dos valores nas barras
          },
          enabled: true,
    }, 

          title: {
            text: 'FILIAIS',
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '22px',
              fontWeight:  'bold',
              color:  '#263238'
            },
          }
  },


  empresaf:'', 
  empresasf:[],   // [] lista       
  filialf:[],   
  filiaisf:[],   // [] lista   
  valor_filial:[],
  tipo:'',
  tipos:[],


/* objetos */

  kpiqtds:[],
  kpitipos:[],  
  kpidias:[],  
  kpidiastotal:[],            // calcular a média de dias
  kpiprograma:[] ,
  kpifuncionario:[],
  kpifiliais:[],
  kpifuncao:[],
  seriestipo:[],
  seriesdia:[],
  seriesprograma:[],
  seriesfuncionario:[],
  seriesfuncao:[],
  seriesPizzaFilial:[] ,

  dt_inicial: '',
  dt_final: '',  

  sinistros:[],
  seriesPizzaFilial:[] ,
  seriesColunaDia:[],  
  seriesfilial:[],  
  value_empresa:[],// [this.empresas],            
  permissoes:[],
  permissao:{},

  mode: 'save',
  carregando: false,
  atualizando: false,   
  value_filial:[],            
  value_status:[],     

        }        
    },

    

    methods: {    
      
            loadEmpresas() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo).then(res => {
            this.empresasf = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, nomeempresarial: emp.nomeempresarial }
            })
          })
      },  
      
      loadFiliais() {
            let corpo = {    
                "id_grupo_empresa": `${this.empresaf.map(e => e.id_empresa)}`,                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiaisf = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
      },


      /// qtd corretivas
      async loadKpiQtd() {
                        let corpo = {    
               "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',                                                                            
              "id_empresa": `${this.user.id_empresa}`,                                                                            
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                                                                       
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                                          
            };
          const url = await `${baseApiUrl}/indicadores/informatica/qtd`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiqtds = res.data             
            })
            .catch(showError)
    },


      /// filtros por dia (PERIODO)

      async loadKpiDia() {
let corpo = {    
               "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',                                                                            
              "id_empresa": `${this.user.id_empresa}`,                                                                            
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                                                                       
                "dt_inicial": `${this.dt_inicial + ' 00:00:00.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.999 -0300'}`,                                                                          
            };
          const url = await `${baseApiUrl}/indicadores/informatica/periodo`
          axios.post(url,corpo)
            .then(res => {              
            this.kpidias = res.data        
            this.updateChartDataDia()            
            })
            .catch(showError)
    },

    

    async updateChartDataDia() {

      this.seriesdia = [{
        name: 'Qtds',
        data: this.kpidias.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartdia.updateOptions({ xaxis:{
        //categories: this.kpidias.map(item => moment(item.dt_visualizacao).format('DD'))        
        //categories: this.kpidias.map(item => moment(item.dt_visualizacao).locale('PT-BR').format('DD/MM/YYYY'))        
        categories: this.kpidias.map(dt => dt.dt_visualizacao)
      }  });       
    },



    /// filtros por operador 19/09/2023
      async loadKpiPrograma() {
            let corpo = {    
               "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',                                                                            
              "id_empresa": `${this.user.id_empresa}`,                                                                            
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                                                                       
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                                          
            };
          const url = await `${baseApiUrl}/indicadores/informatica/programa`
          axios.post(url,corpo)
            .then(res => {              
            this.kpiprograma = res.data 
            this.updateChartDataprograma();               
            })
            .catch(showError)
    },
    
    async updateChartDataprograma() {
      this.seriesprograma = [{
        name: 'Qtd programas',
        data: this.kpiprograma.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartprograma.updateOptions({ xaxis:{
        categories: this.kpiprograma.map(r => r.programa)
      }  });       
    },

        /// filtros por função 06/12/2023 as 15:45h
      async loadKpiFuncao() {
            let corpo = {    
              "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',                                                                            
              "id_empresa": `${this.user.id_empresa}`,                                                                            
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                                                                                                                         
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            };
          const url = await `${baseApiUrl}/indicadores/informatica/funcao`
          axios.post(url,corpo)
            .then(res => {              
            this.kpifuncao = res.data 
            this.updateChartDataFuncao();               
            })
            .catch(showError)
    },
    
    async updateChartDataFuncao() {
      this.seriesfuncao = [{
        name: 'Qtd acesso por função',
        data: this.kpifuncao.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartfuncao.updateOptions({ xaxis:{
        categories: this.kpifuncao.map(r => r.funcao)
      }  });       
    },

    /// filtros por funcionario 06/12/2023
    async loadKpiFuncionario() {
            let corpo = {    
              "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',                                                                            
              "id_empresa": `${this.user.id_empresa}`,                                                                            
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                                                                                                         
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                            
            };
          const url = await `${baseApiUrl}/indicadores/informatica/funcionario`
          axios.post(url,corpo)
            .then(res => {              
            this.kpifuncionario = res.data 
            this.updateChartDataFuncionario();               
            })
            .catch(showError)
    },
    
    async updateChartDataFuncionario() {
      this.seriesfuncionario = [{
        name: 'Qtd',
        data: this.kpifuncionario.map(item => parseInt(item.qtd)),
        }];
      this.$refs.chartfuncionario.updateOptions({ xaxis:{
        categories: this.kpifuncionario.map(r => r.regfuncao)
      }  });       
    },

    
      /// filtros por filial  getKpiInformaticaFilial
      async loadKpiFilial() {
            let corpo = {    
               "empresa_id": this.empresaf ? `${this.empresaf.map(e => e.id_empresa)}` : '',                                                                            
              "id_empresa": `${this.user.id_empresa}`,                                                                            
              "filial_id": `${this.valor_filial.map(f => f.id_filial_erp)}`,                                                                       
                "dt_inicial": `${this.dt_inicial + ' 00:00:01.000 -0300'}`,                                            
                "dt_final": `${this.dt_final + ' 23:59:59.000 -0300'}`,                                                                          
            };
          const url = `${baseApiUrl}/indicadores/informatica/filial`
          axios.post(url,corpo)
            .then(res => {
              this.kpifiliais = res.data                
              this.updateChartDataFilial();              
            })
            .catch(showError)
      },

      async updateChartDataFilial() {                                                      
            this.graficoPizzaFilial.series = this.kpifiliais.map(item => parseInt(item.qtd));
            this.atualizarLabels()
      },

      async atualizarLabels() {
        this.graficoPizzaFilial.labels = await this.kpifiliais.map(item => item.filial);        
        this.$refs.chart.updateOptions({ labels: this.graficoPizzaFilial.labels });              
      },












    },




    mounted(){
      this.loadEmpresas()      
      this.loadKpiDia()
      this.loadKpiPrograma()
      this.loadKpiFuncao()   
      this.loadKpiFuncionario()  
      this.loadKpiFilial()
      this.loadKpiQtd()
    },

    
   
  



}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>





</style>